<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <template v-slot:message>
      <p v-html="formatChatMessage"></p>
    </template>

    <ul class="chat-message__actions" :class="style['selector-widget']">
      <li
        v-for="(option, index) in chat.message_rich.options"
        :key="index"
        :class="style['mn-list']"
      >
        <label :class="style['checkbox-option']">
          <p>{{ option.description }}</p>
          <counter
            v-if="option.select_type !== 'checkbox'"
            :index="index"
            :count="tierCount.data[index].count"
            :decrease-count="decreaseCount"
            :increase-count="increaseCount"
          />
          <checkbox
            v-else
            :checked="!!tierCount.data[index].count"
            :index="index"
            :toggle-check="toggleCheck"
          />
        </label>
      </li>
    </ul>

    <ul class="chat-message__actions">
      <li
        v-for="(action, index) in chat.message_rich.actions"
        :key="index"
        v-theme-bg-hover
        @click="sendInformation(action)"
      >
        {{ action.text }}
      </li>
    </ul>
  </chat-message>
</template>

<script>
import { lineBreaks } from 'Utilities'
import { Chat } from 'src/apis'
import Counter from 'UtilityComponents/Counter.vue'
import Checkbox from 'UtilityComponents/Checkbox.vue'
import style from './scss/_selector_widget.scss'
import ChatMessage from 'Chats/ChatMessage'
import chatWidgetMixin from 'Chats/mixins/chatWidgetMixin'
import { useChatStore } from 'Store/chat'

export default {
  components: {
    ChatMessage,
    Counter,
    Checkbox
  },
  mixins: [chatWidgetMixin],

  setup() {
    const chatStore = useChatStore()

    return { chatStore }
  },

  data() {
    return {
      style,
      tierCount: this.buildTierCount() // type: object { data: [array of objects] }
    }
  },
  computed: {
    formatChatMessage() {
      return lineBreaks(this.chat.message_rich.message)
    },
    chatID() {
      return this.chatStore.chatId
    }
  },
  methods: {
    buildTierCount() {
      const services = this.chat.message_rich.options
      return {
        data: services.map((service, index) => {
          return {
            code: service.code,
            count: service.count || 0, // default setting
            maxCount: service.max_count || 100,
            countAsGroup: service.count_as_group,
            price: service.price
          }
        })
      }
    },
    decreaseCount(index) {
      const minimum = 0
      if (this.tierCount.data[index].count > minimum) {
        this.tierCount.data[index].count -= 1
      } else {
        this.tierCount.data[index].count = 0
      }
    },
    increaseCount(index) {
      const maxCount = this.tierCount.data[index].maxCount

      if (this.tierCount.data[index].countAsGroup) {
        let groupCount = 0
        this.tierCount.data.forEach((d) => {
          if (this.tierCount.data[index].countAsGroup.includes(d.code)) {
            groupCount += d.count
          }
        })

        if (maxCount <= groupCount) return
      }

      if (this.tierCount.data[index].count < maxCount) {
        this.tierCount.data[index].count += 1
      }
    },
    toggleCheck(index) {
      this.tierCount.data[index].count = Number(!this.tierCount.data[index].count)
    },
    composeReply() {
      const replyArray = []
      this.tierCount.data.map((tier, index) => {
        const option = this.chat.message_rich.options[index]
        let sentence = option.description
        let answer = null
        if (option.select_type === 'checkbox') {
          answer = tier.count ? 'Yes' : 'No'
          sentence += `: ${answer}`
        } else if (tier.count !== 0) {
          answer = tier.count
          sentence += `: ${answer}`
        }
        answer && replyArray.push(sentence)
      })

      if (replyArray.length === 0) replyArray.push('No kids')

      return replyArray.join('\n')
    },
    sendInformation(action) {
      // TODO: add active status to this widget
      if (action.step === 'back') {
        // user clicked back button, call API and return
        Chat.goToState(this.chatID)
        return
      }
      const messageAction = JSON.stringify(this.tierCount)
      const replyText = this.composeReply()
      Chat.sendMessage(replyText, { messageAction, messageID: this.chat.id })
    }
  }
}
</script>
